var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"archiveContainer profile-body-modal mx-3"},[_c('p',[_vm._v("Are you sure you want to deactivate the user's account?")])])}]

export { render, staticRenderFns }